<template>
  <div>
    <svg viewBox="0 0 500 500">
      <text :class="this.quadrantNameClass(1 == data.quadrant)" x="345" y="155">
        1
      </text>
      <text :class="this.quadrantNameClass(2 == data.quadrant)" x="345" y="380">
        2
      </text>
      <text :class="this.quadrantNameClass(3 == data.quadrant)" x="105" y="380">
        3
      </text>
      <text :class="this.quadrantNameClass(4 == data.quadrant)" x="105" y="155">
        4
      </text>

      <line class="radial" x1="40" y1="40" x2="460" y2="460"></line>
      <line class="radial" x1="460" y1="40" x2="40" y2="460"></line>

      <line class="XandY" x1="250" y1="30" x2="250" y2="470"></line>
      <line class="XandY" x1="30" y1="250" x2="470" y2="250"></line>

      <text text-anchor="middle" x="250" y="20">experiencing</text>
      <text text-anchor="middle" x="250" y="490">conceptualizing</text>
      <text
        text-anchor="middle"
        x="15"
        y="250"
        transform="rotate(-90, 15, 250)"
      >
        doing
      </text>
      <text
        text-anchor="middle"
        x="480"
        y="250"
        transform="rotate(90, 480, 250)"
      >
        watching
      </text>

      <circle
        class="marker"
        :cx="this.calculateX(1, 10)"
        :cy="calculateY(1, 10)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(1, 20)"
        :cy="calculateY(1, 20)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(1, 30)"
        :cy="calculateY(1, 30)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(1, 40)"
        :cy="calculateY(1, 40)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(1, 50)"
        :cy="calculateY(1, 50)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(1, 60)"
        :cy="calculateY(1, 60)"
        r="2"
      />

      <circle
        class="marker"
        :cx="this.calculateX(2, 10)"
        :cy="calculateY(2, 10)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(2, 20)"
        :cy="calculateY(2, 20)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(2, 30)"
        :cy="calculateY(2, 30)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(2, 40)"
        :cy="calculateY(2, 40)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(2, 50)"
        :cy="calculateY(2, 50)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(2, 60)"
        :cy="calculateY(2, 60)"
        r="2"
      />

      <circle
        class="marker"
        :cx="this.calculateX(3, 10)"
        :cy="calculateY(3, 10)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(3, 20)"
        :cy="calculateY(3, 20)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(3, 30)"
        :cy="calculateY(3, 30)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(3, 40)"
        :cy="calculateY(3, 40)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(3, 50)"
        :cy="calculateY(3, 50)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(3, 60)"
        :cy="calculateY(3, 60)"
        r="2"
      />

      <circle
        class="marker"
        :cx="this.calculateX(4, 10)"
        :cy="calculateY(4, 10)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(4, 20)"
        :cy="calculateY(4, 20)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(4, 30)"
        :cy="calculateY(4, 30)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(4, 40)"
        :cy="calculateY(4, 40)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(4, 50)"
        :cy="calculateY(4, 50)"
        r="2"
      />
      <circle
        class="marker"
        :cx="this.calculateX(4, 60)"
        :cy="calculateY(4, 60)"
        r="2"
      />

      <template v-if="data.quadrant">
        <circle
          :cx="this.calculateX(1, data.q1)"
          :cy="calculateY(1, data.q1)"
          r="4"
        />
        <circle
          :cx="this.calculateX(2, data.q2)"
          :cy="calculateY(2, data.q2)"
          r="4"
        />
        <circle
          :cx="this.calculateX(3, data.q3)"
          :cy="calculateY(3, data.q3)"
          r="4"
        />
        <circle
          :cx="this.calculateX(4, data.q4)"
          :cy="calculateY(4, data.q4)"
          r="4"
        />

        <line
          class="connector"
          :x1="this.calculateX(1, data.q1)"
          :y1="calculateY(1, data.q1)"
          :x2="this.calculateX(2, data.q2)"
          :y2="calculateY(2, data.q2)"
        ></line>
        <line
          class="connector"
          :x1="this.calculateX(2, data.q2)"
          :y1="calculateY(2, data.q2)"
          :x2="this.calculateX(3, data.q3)"
          :y2="calculateY(3, data.q3)"
        ></line>
        <line
          class="connector"
          :x1="this.calculateX(3, data.q3)"
          :y1="calculateY(3, data.q3)"
          :x2="this.calculateX(4, data.q4)"
          :y2="calculateY(4, data.q4)"
        ></line>
        <line
          class="connector"
          :x1="this.calculateX(4, data.q4)"
          :y1="calculateY(4, data.q4)"
          :x2="this.calculateX(1, data.q1)"
          :y2="calculateY(1, data.q1)"
        ></line>
      </template>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, default: () => {} }
  },
  methods: {
    calculateX(quadrant, value) {
      let center = 250
      let countSize = 210 / (60 * 0.707)

      let relativeX = parseFloat(value) * countSize * 0.7071
      let x = 0

      if (quadrant == 1 || quadrant == 2) {
        x = relativeX + center
      } else {
        x = center - relativeX
      }

      return x
    },
    calculateY(quadrant, value) {
      let center = 250
      let countSize = 210 / (60 * 0.707)

      let relativeY = parseFloat(value) * countSize * 0.7071
      let y = 0

      if (quadrant == 2 || quadrant == 3) {
        y = relativeY + center
      } else {
        y = center - relativeY
      }

      return y
    },
    quadrantNameClass(isUserQuadrant) {
      if (isUserQuadrant) {
        return "quad-name-user"
      } else {
        return "quad-names"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

line.XandY {
  stroke: $dark-yellow;
  stroke-width: 2px;
}

line.radial {
  stroke: $light-yellow;
  stroke-width: 1px;
}

line.connector {
  stroke: $light-grey;
  stroke-width: 1px;
}
circle {
  stroke: $dark-grey;
  fill: $dark-grey;
}

circle.marker {
  stroke: $dark-yellow;
  fill: $dark-yellow;
}

text {
  text-transform: uppercase;
  font-size: 0.8em;
  fill: $light-grey;
}

text.quad-names {
  font-size: 6em;
  stroke: $light-grey;
  fill: $white;
}

text.quad-name-user {
  font-size: 6em;
  fill: $light-grey;
  fill: $light-grey;
}
</style>
